// @flow
import merge from 'lodash/merge';
import type { EnvironmentConfig } from 'model/EnvironmentConfig';
import staging from 'appconfig/envs/staging';

export default (): EnvironmentConfig =>
  merge(staging(), {
    clicktaleEnabled: false,
    atlAdminUrl: 'https://admin.stg.atlassian.com',
    hamsUrl: '/hams',
    logoutUrl: () => '#logout',
    i18nUrl: 'https://cart-static.ap-southeast-2.dev.public.atl-paas.net/i18n',
    sentry: {
      environment: 'local',
    },
    root: 'http://localhost:3000/purchase',
    adminHubUrl: 'https://admin.stg.atlassian.com',
    statsigClientSDK: 'aed6e833-9555-48d3-8812-a54fbb2db5dc',
    emailMAC: (userEmail) =>
      `https://id.stg.internal.atlassian.com/login?application=mac&continue=https://id.stg.internal.atlassian.com/manage-profile&prompt=none&login_hint=${userEmail}`,
    billingDetailsMAC: 'http://localhost:3000/purchase/my/edit-details',
    switchUserMAC: 'http://localhost:3000/purchase/my/config',
    switchAccountMAC:
      'https://id.stg.internal.atlassian.com/login?application=mac&continue=https://wac.stg.internal.atlassian.com/purchase/my&prompt=select_account',
    logOutMAC:
      'https://id.stg.internal.atlassian.com/logout?application=mac&continue=https://wac.stg.internal.atlassian.com/purchase/my',
    calculatePricingURL:
      'https://wac.stg.internal.atlassian.com/migration/assess/calculate-pricing',
    ppcUrl: 'https://ppc.stg.atlassian.com',
    bitbucketCmtUrl: 'https://integration.bb-inf.net/',
    migrationLink: 'https://www.atlassian.com/migration',
    omniChannelGraphQLUrl: 'https://wac.stg.internal.atlassian.com/gateway/api/graphql',
    omniChannelFlowId: '928ba5ad-5618-4213-874d-e3766b74e784',
    omniChannelEnvironment: 'staging',
  });
